module.exports = __webpack_public_path__ + "img/logo.21d0856a.png";